import actions from "../../constants/actions";

export const loadLessons = (begin, end) => {
    return {
        type: actions.LESSONS.LOAD_LIST,
        payload: {
            begin: begin.toISODate(),
            end: end.toISODate(),
        },
    };
};

export const loadLesson = (slug) => {
    return {
        type: actions.LESSONS.LOAD,
        payload: {
            slug,
        },
    };
};

export const loadEvent = (slug) => {
    return {
        type: actions.EVENTS.LOAD,
        payload: {
            slug,
        },
    };
};
